import React from "react";

// Material components
import { Box, Skeleton, Typography } from "@mui/material";

// Hooks
import { useIntl } from "react-intl";

// Components
import ChipsArray from "components/Domain/ChipsArray";
import CustomIcon from "components/CustomIcon";

//Styles
import peersStyles from "./PeersChip.styles";

// Others
import icons from "enums/icons";

// Types
import { ChipEntity } from "types";
import { RequestInfo } from "store/slice/store.types";

// Constants
import { PEERS_LIMIT } from "constants/constants";

// Ability
import { Peer } from "services";

const PeersChip = ({
    peers,
    status,
    onChange,
    erasable,
    headerRightSide,
}: {
    peers: Peer[];
    status: RequestInfo;
    onChange: (chips: ChipEntity[]) => void;
    erasable: boolean;
    headerRightSide: React.ReactNode;
}) => {
    const classes = peersStyles();
    const intl = useIntl();

    const innerPeers = peers.slice(0, PEERS_LIMIT).map((peer) => ({ ...peer, erasable }));
    const noPeersSelected = peers.every((peer) => !peer.selected);

    return (
        <Box className={classes.container}>
            <Box display="flex" alignItems="baseline" justifyContent="space-between">
                <Box className={classes.peerItem}>
                    <CustomIcon icon={icons.peer} className={`${classes.peerItemIcon} ItemIcon`} />
                    <Box component="span">
                        {intl.formatMessage({
                            id: "setup-company.domain.peers",
                        })}
                    </Box>
                </Box>
                {headerRightSide}
            </Box>
            {status === "fetching" ? (
                <>
                    <Skeleton animation="wave" height={50} />
                </>
            ) : !noPeersSelected ? (
                <Box className={classes.chipsContainer}>
                    <ChipsArray
                        autocompleteTagsFor="peers"
                        chipData={innerPeers}
                        erasable={erasable}
                        onListChange={onChange}
                    />
                </Box>
            ) : (
                <Box className={classes.noPeersTextContainer}>
                    <Typography>{intl.formatMessage({ id: "setup-company.domain.peers.noPeersMessage" })}</Typography>
                </Box>
            )}
        </Box>
    );
};

export default PeersChip;
